import { EditOutlined, PlusOutlined } from "@ant-design/icons";
import { Button } from "antd";
import React from "react";

const PlusButton = (props) => {
  return (
    <Button
      className="text-white flex items-center justify-center p-2 !bg-[#07b553] 
      !border-[#07b553] hover:!bg-[#38cb82] hover:!border-[#38cb82]
      hover:!text-white active:!text-white focus:!text-white"
      {...props}
    >
      <PlusOutlined />
    </Button>
  );
};

export default PlusButton;
